module.exports = __webpack_public_path__ + "img/account-notification-bing.5ead352e.svg";